import React from 'react';
import { Avatar } from '@mui/material';

const UserLogo = ({ 
  photoUrl, 
  userName, 
  size = 80, 
  variant = "circular",
  sx = {}
}) => {
  if (photoUrl) {
    return (
      <Avatar
        variant={variant}
        src={photoUrl}
        alt={`${userName} logo`}
        sx={{ 
          width: size, 
          height: size,
          mx: 'auto', 
          mb: 2,
          ...sx
        }}
      />
    );
  }
  
  return (
    <Avatar 
      variant={variant}
      sx={{ 
        width: size, 
        height: size, 
        mx: 'auto', 
        mb: 2,
        bgcolor: 'grey.300',
        fontSize: size > 80 ? 24 : 20,
        ...sx
      }}
    >
      {userName.split(' ').map(n => n[0]).join('')}
    </Avatar>
  );
};

export default UserLogo;